import React from "react";
import { faCircleNotch } from "@awesome.me/kit-cae4660dd3/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const EducatorContentSpinner = () => (
  <FontAwesomeIcon size="2x" className="animation spinner d-flex mx-auto" icon={faCircleNotch} />
);

export default EducatorContentSpinner;
